import { graphql } from "gatsby"
import React from "react"

import ArticleTemplate from "../components/ArticleTemplate"
import { HeadLayout } from "../layouts/head"

function BlogPostTemplate({ data }) {
  return (
    <ArticleTemplate
      type="post"
      item={data.post}
      defaultRelatedItems={data.defaultRelatedPosts}
    />
  )
}

export function Head({ data }) {
  const {
    post: { seo },
  } = data

  return <HeadLayout seo={seo} />
}
export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostById($id: String!, $locale: String!) {
    post: wpPost(id: { eq: $id }) {
      ...PostFragment
    }
    defaultRelatedPosts: allWpPost(
      limit: 3
      filter: { id: { nin: [$id] }, language: { locale: { eq: $locale } } }
    ) {
      nodes {
        ...PostGeneralFragment
      }
    }
  }
`
